export const actionTypes = {
    getData: "[multiPublisherYield] Get data",
};

export const mutationTypes = {
    yieldStart: "[multiPublisherYield] Yield get data start",
    yieldSuccess: "[multiPublisherYield] Yield get data success",
    yieldFailure: "[multiPublisherYield] Yield get data failure",
};

export const getterTypes = {
    getYieldData: "[multiPublisherYield] Get yield data",
    getYieldMetadata: "[multiPublisherYield] Get yield metadata",
    getYieldCsvData: "[multiPublisherYield] Get yield csvdata",
    isLoading: "[multiPublisherYield] Get isLoading",
};
